import type { Account } from '@repo/api-gw-sdk';

import { CloudProviders } from '@/data/inventory/data';
import type { MultiSelectConditionComponentProps } from '@/types/advanceFilter';

import { MultiSelectConditionPanel } from '../conditions/conditionComponents';
import { CircleImage } from '../shared/circleImage';

export const AccountCondition = (
  props: {
    accounts?: Account[];
  } & MultiSelectConditionComponentProps
) => {
  return (
    <MultiSelectConditionPanel
      showAddNewButton
      showSearchBox
      isLoading={props.isLoading ?? false}
      entityName={props.entityName || props.property.displayName.toLowerCase()}
      shouldShowId
      options={(props.accounts || []).map((account) => ({
        id: account.providerAccountId,
        name: account.name,
        Image: (
          <CircleImage
            alt={
              CloudProviders[account.cloudProvider]?.displayName ||
              account.cloudProvider
            }
            src={CloudProviders[account.cloudProvider]?.logo}
            className='my-[16px]'
          />
        ),
      }))}
      {...props}
    />
  );
};
